import { Order } from '../types/components/table/order'

function genericComparator<T>(a: T, b: T, orderBy: keyof T, nestedOrderBy?: string): number {
  const orderByStr = String(orderBy)
  const valA = getNestedValue(a, nestedOrderBy ? [orderByStr, nestedOrderBy] : [orderByStr])
  const valB = getNestedValue(b, nestedOrderBy ? [orderByStr, nestedOrderBy] : [orderByStr])

  if (valA == null || valB == null) return 0

  if (typeof valA === 'string' && typeof valB === 'string') {
    return valA.toLowerCase().localeCompare(valB.toLowerCase())
  }

  return valA < valB ? -1 : valA > valB ? 1 : 0
}

function getNestedValue<T>(obj: any, keys: string[]): T | undefined {
  if (keys.length === 0) return obj as T
  if (obj == null) return undefined

  const keyExpression = keys[0]
  if (keyExpression.includes('+')) {
    return keyExpression
      .split('+')
      .map(k => obj[k.trim()])
      .filter(v => v !== undefined && v !== null)
      .join('') as T
  }
  return getNestedValue<T>(obj[keys[0]], keys.slice(1))
}

export function getComparator<T>(order: Order, orderBy: keyof T, nestedOrderBy?: string): (a: T, b: T) => number {
  return order === 'desc'
    ? (a, b) => genericComparator(a, b, orderBy, nestedOrderBy)
    : (a, b) => -genericComparator(a, b, orderBy, nestedOrderBy)
}

export function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

export const sortVacationPeriodsByDate = <T extends { startDate: any }>(periods: T[]): T[] => {
  return [...periods].sort((a, b) => {
    const dateA = a.startDate
    const dateB = b.startDate
    if (dateA == null || dateB == null) return 0

    if (typeof dateA === 'string' && typeof dateB === 'string') {
      return dateA.localeCompare(dateB)
    }

    const timeA = dateA.valueOf ? dateA.valueOf() : dateA
    const timeB = dateB.valueOf ? dateB.valueOf() : dateB
    return timeA < timeB ? -1 : timeA > timeB ? 1 : 0
  })
}
